/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Many/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaSelectOneValues from 'DesignSystem/TysiaSelectOne/TysiaSelectOneValues/index'



/** @type {import('Simple/types.js').View} */
export default function Many({
  children,
  viewPath = "/App/Account/Content/PatientsList/Filters/WidgetTypeChooser/Content/Many",
  onChange
  
}) {
let widgetTypesValueData = fromData.useDataValue({ viewPath,
context: 'widget_types',
})
let tabSelectedWidgetTypesValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.widget_types',
})
let tabSelectedWidgetTypesChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.widget_types',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="widget_types"
 from={widgetTypesValueData}
 data="tab.selected.widget_types"
 onChange={tabSelectedWidgetTypesChangeData}
 value={tabSelectedWidgetTypesValueData}
 maxWidth={220}
 flexGrow={0}
 size="small"
 marginLeft={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Widgets"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
<TysiaSelectOneValues
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneValues`}
/>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}